import type { RefObject } from 'react';
import { useEffect } from 'react';

type useScrollToProps = {
  xCoord?: number;
  yCoord?: number;
};

function useScrollTo(element: RefObject<HTMLDivElement> | null, options: useScrollToProps) {
  const scrollTo = (position: useScrollToProps) => {
    if (element.current) {
      element.current.scroll(position.xCoord || 0, position.yCoord || 0);
    }
  };

  useEffect(() => {
    scrollTo(options);
  }, [element]);
}

export default useScrollTo;
